import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { TrocarPerfilComponent } from "./trocar-perfil.component";

@NgModule({
    entryComponents: [TrocarPerfilComponent],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule
    ],
    declarations: [TrocarPerfilComponent],
    exports: [
        TrocarPerfilComponent
    ]
})
export class TrocarPerfilComponentModule { }
